import { BaseNodeConfig } from 'dto/NodeConfig';
import { NodeConnectionUi } from 'classes/NodeConnectionUi';
import { NodeConnection, NodeConnectionNames } from 'dto/NodeConnection';
import { ExpressionMethodDto } from 'dto/ExpressionMethodDto';
import { NodeUi } from 'classes/NodeUi';
import { FlowService } from 'services/flow.service';
import { NodeTypeComponent } from './../node-type/node-type.component';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { UiElementType } from 'classes/UIElementType';

@Component({
  selector: 'ngbd-modal-content',
  styleUrls: ['./node-info.component.css'],
  templateUrl: './node-info.component.html'
})
export class NgbdModalContent implements OnInit {

  UIElementType = UiElementType;  
  @Input() node:NodeUi;
  elementTypes:string[];
  newOutput:string = null;

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal){
    this.elementTypes = Object.keys(this.UIElementType).filter(k => !isNaN(Number(k)));
  }

  ngOnInit() {
      
  }

  /** Add a new childnode to this node triggered by the new Result value */
  addOutput():void{
    this.node.Flow.addNewNode(new NodeConnectionUi(this.node,new NodeConnection(this.node.dto.Identifier,NodeConnectionNames.RESULT,this.newOutput),this.node.GetEndOfThisGroup()));
    this.node.Flow.ReRender();
    this.node.Flow.Save();
  }
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/node-info/node-info.component.ts